<script lang="ts">
  import { onMount } from "svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    filter?: string
    filters: any[]
    onaddfilter: (filter: any) => void
    onselected: (tab: string) => void
  }

  let { filter = "", filters, onaddfilter, onselected }: Props = $props()
  let index: number = $state(null)
  let reg: RegExp = $state()

  const userRoles = ["admin", "leader", "manager", "member"]

  const usersList: UserType[] = appStore.users.filter((user) => {
    return userRoles.includes(user.role)
  })
  let users = $state(usersList)

  let selectedUsers: UserType[] = $state([])
  let opts = usersList.filter((v) => !selectedUsers.includes(v.id))

  export function resetIndex() {
    index = null
  }

  export function moveDown(): void {
    if (index === null) {
      index = 0
      return
    }
    if (index + 1 === users.length) {
      index = 0
    } else {
      index++
    }
  }

  export function moveUp() {
    if (index === null) {
      index = users.length - 1
      return
    }
    if (index === 0) {
      index = users.length - 1
    } else {
      index--
    }
  }

  export function selectIndex() {
    if (index !== null) {
      const filter = users[index]
      onaddfilter(filter)
      index = null
    }
  }

  let tab = $state("Receiver")
  function setTab(txt): void {
    tab = txt
    onselected(tab)
  }

  onMount(() => {
    selectedUsers = filters.filter((v) => v.id).map((v) => v.id)
    opts = usersList.filter((v) => !selectedUsers.includes(v.id))

    if (filter !== undefined && filter !== "") {
      reg = new RegExp(filter, "i")
      users = opts.filter((user) => {
        return reg.test(user.name)
      })
    } else {
      users = opts
    }

    onselected(tab)
  })
</script>

<div class="autocomplete-container">
  <div class="px-4 py-1 tabs">
    <button
      class="rounded button-tab"
      class:active={tab === "Receiver"}
      onclick={() => setTab("Receiver")}
    >
      Receiver
    </button>
    <button
      class="rounded button-tab"
      class:active={tab === "Sender"}
      onclick={() => setTab("Sender")}
    >
      Sender
    </button>
    <button
      class="rounded button-tab"
      class:active={tab === "Sender/Receiver"}
      onclick={() => setTab("Sender/Receiver")}
    >
      Sender/Receiver
    </button>
  </div>

  <div class="" data-name="statuses">
    {#each users as user, idx (idx)}
      <div
        class="px-4 py-2 cursor-pointer item"
        class:bg-blue-100={idx === index}
        onmouseenter={() => {
          index = idx
        }}
        onclick={() => {
          onaddfilter(user)
          index = null
        }}
      >
        {user.name}
      </div>
    {/each}
  </div>
</div>

<style lang="css">
  .autocomplete-container {
    max-height: 50vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .tabs button {
    padding: 0.1rem 0.4rem;
    background-color: #dbe9fe;
    font-weight: 600;
    margin-right: 0.4rem;
    color: #6b7280;
  }
  .tabs button.active {
    background-color: #075985;
    color: white;
  }
</style>
